const categoriesNameUa = {
  "Main expenses": "Головні витрати",
  Products: "Продукти",
  Car: "Автомобіль",
  "Self care": "Розвиток",
  "Child care": "Дитина",
  "Household products": "Дім",
  Education: "Освіта",
  Leisure: "Дозвілля",
  "Other expenses": "Інші",
  Entertainment: "Розваги",
  Income: "Дохід",
};

export default categoriesNameUa;
